// ======================================================================
// File Name       : EmailListContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { getFormValues, isInvalid, reduxForm } from 'redux-form';
import * as EmailAction from '../../actions/EmailAction';
import DialogConfirm from '../../components/DialogConfirm';
import EmailList from '../../components/email/EmailList';
import EmailSearch from '../../components/email/EmailSearch';
import SelectGroupDlg from '../../components/group/SelectUserGroupDialog';
import Header from '../../components/Header';
import MessageSearch from '../../components/MessageSearch';
import ModalConductor from '../../components/modal/ModalConductor';
import { MAIL_SEND_STATUS, MAIL_SEND_STATUS_TYPE } from '../../constants/EmailConstants';
import { DEFAULT_DATE_FORMAT_SEARCH, RETURN_MAX_NUM, SELECT_TARGET_DATA } from '../../constants/index';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { EMAIL_LIST } from '../../constants/PathConstants';
import { showExportCSVSuccessMessage } from '../../utils/index';
import { hideLoading, showLoading } from '../../utils/PageUtils';

class EmailListContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showExportModal: false,
      showSelectGroup: false,
      showDetailDialog: false,
      isAllowShowSearchMessage: false,
      filterData: {},
      searchInfo: {
        selectedGroup: {},
      },
    };

    this.showSelectGroupDlg = this.showSelectGroupDlg.bind(this);
    this.cancelSelectGroupDlg = this.cancelSelectGroupDlg.bind(this);
    this.okSelectGroupDlg = this.okSelectGroupDlg.bind(this);
    this.removeSelectedGroup = this.removeSelectedGroup.bind(this);
    this.handleShowDetailDialog = this.handleShowDetailDialog.bind(this);
    this.handleCloseDetailDialog = this.handleCloseDetailDialog.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.openFileExportConfirm = this.openFileExportConfirm.bind(this, MessageTemplate.BULK_EXPORT, null);
    this.onFileExportCancel = this.onFileExportCancel.bind(this);
    this.onFileExportOk = this.onFileExportOk.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.searchData = this.searchData.bind(this);
    this.initData = this.initData.bind(this);
    this.createParams = this.createParams.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.clickSearchButton = this.clickSearchButton.bind(this);
    this.searchData = this.searchData.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  componentDidMount() {
    this.initData();
  }

  initData() {
    const { initialValues } = this.props;
    let column = null;
    let startPosition = 0;
    if (initialValues) {
      if (initialValues.emailSortType) {
        column = initialValues.emailSortType;
      }
      if (initialValues.startPosition) {
        startPosition = initialValues.startPosition;
      }
      const sendDateFromTmp = moment().add(-1, 'month');
      const sendDateToTmp = moment();
      this.props.change('sendDateFrom', sendDateFromTmp);
      this.props.change('sendDateTo', sendDateToTmp);
      initialValues.sendDateFrom = sendDateFromTmp;
      initialValues.sendDateTo = sendDateToTmp;
    }

    const param = this.createParams(false, initialValues, column, startPosition);
    this.props.dispatch(EmailAction.fetchGroupStructure());
    this.props.dispatch(EmailAction.getEmailList(param));
  }

  clickSearchButton() {
    const { dispatch, formValues, invalid } = this.props;
    const { selectedGroup } = this.state;
    if (invalid) {
      return;
    }
    const filterData = {
      ...this.state.filterData,
      emailTitle: formValues.emailTitle,
      userName: formValues.userName,
      groupSecernId: selectedGroup?.groupSecernId,
      sendDateFrom: formValues.sendDateFrom,
      sendDateTo: formValues.sendDateTo,
      emailSendStatus: formValues.emailSendStatus,
      emailSortType: formValues.emailSortType,
      ascendingDescendingSort: formValues.ascendingDescendingSort,
      startPosition: formValues.startPosition,
    };
    this.setState({ filterData }, () => {
      const param = this.createParams(false, filterData, null, 0);
      this.props.change('startPosition', 0);
      this.props.change('emailSortType', null);
      this.props.change('ascendingDescendingSort', null);
      this.props.dispatch(showLoading());
      dispatch(EmailAction.getEmailList(param)).then(() => {
        this.setState({ isAllowShowSearchMessage: true });
        this.props.dispatch(hideLoading());
      });
    });
  }

  createParams(isCSV, data, column, startPosition) {
    const filterData = {};
    const { selectedGroup } = this.state.searchInfo;
    const groupSecernId = selectedGroup?.groupSecernId;
    if (groupSecernId) { // Get groupSecernId from state
      filterData.groupSecernId = groupSecernId;
    }
    if (data && data.emailTitle) {
      filterData.emailTitle = data.emailTitle;
    }
    if (data && data.userName) {
      filterData.userName = data.userName;
    }
    if (data && data.sendDateFrom) {
      const sendDateFrom = data.sendDateFrom ? moment(data.sendDateFrom).format(DEFAULT_DATE_FORMAT_SEARCH) : '';
      filterData.sendDateFrom = sendDateFrom;
    }
    if (data && data.sendDateTo) {
      const sendDateTo = data.sendDateTo ? moment(data.sendDateTo).format(DEFAULT_DATE_FORMAT_SEARCH) : '';
      filterData.sendDateTo = sendDateTo;
    }
    if (data && data.emailSendStatus) {
      if (data.emailSendStatus === MAIL_SEND_STATUS_TYPE.FAILED) {
        filterData.emailSendStatusList = Array.of(MAIL_SEND_STATUS.CANCELED,
          MAIL_SEND_STATUS.UNKNOWN_DESTINATION,
          MAIL_SEND_STATUS.ERROR_BLACK_LIST,
          MAIL_SEND_STATUS.FAILED);
      }
      if (data.emailSendStatus === MAIL_SEND_STATUS_TYPE.SUCCESS) {
        filterData.emailSendStatusList = Array.of(MAIL_SEND_STATUS.DELIVERED);
      }
    }
    if (!isNaN(parseInt(startPosition, 10))) {
      filterData.startPosition = startPosition;
    }
    if (column && Object.keys(column).length) {
      filterData.ascendingDescendingSort = column.sortState;
      filterData.emailSortType = column.sortBy;
    }

    filterData.returnMaxNum = RETURN_MAX_NUM;

    let selectTargetData = SELECT_TARGET_DATA.DATA;
    if (isCSV) {
      selectTargetData = SELECT_TARGET_DATA.CSV;
      filterData.returnMaxNum = null;
      filterData.startPosition = null;
      filterData.ascendingDescendingSort = null;
      filterData.emailSortType = null;
    }
    const param = {
      selectTargetData,
      searchInfo: filterData,
    };
    return param;
  }

  handleShowDetailDialog(emailInfo) {
    const { dispatch } = this.props;
    dispatch(EmailAction.getEmailDetail(emailInfo));
    dispatch(EmailAction.showMailDetailDialog());
  }

  handleCloseDetailDialog() {
    this.setState({ showDetailDialog: false });
  }

  showSelectGroupDlg() {
    this.setState({ showSelectGroup: true });
  }

  cancelSelectGroupDlg() {
    this.setState({ showSelectGroup: false });
  }

  okSelectGroupDlg(group) {
    const searchInfo = {
      ...this.state.searchInfo,
      ...{ selectedGroup: group },
    };
    this.setState({
      showSelectGroup: false,
      searchInfo,
    });
  }

  removeSelectedGroup() {
    const { searchInfo } = this.state;
    searchInfo.selectedGroup = {};
    this.setState({
      searchInfo,
    });
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  handleSortState(column) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let startPosition = 0;
    if (formValues && formValues.startPosition) {
      startPosition = formValues.startPosition;
    }
    this.searchData(startPosition, column);
  }

  searchData(startPosition, column) {
    const { invalid, formValues } = this.props;
    if (invalid) { return; }
    const paramSearch = this.createParams(false, formValues, column, startPosition);
    this.props.dispatch(EmailAction.getEmailList(paramSearch)).then(() => {
      this.setState({ isAllowShowSearchMessage: true });
    });
  }

  openFileExportConfirm(mdContent, mdSize) {
    const { formValues } = this.props;
    if (
      formValues &&
      (!formValues.syncErrors || formValues.syncErrors.length === 0)
    ) {
      this.content = mdContent;
      this.mdSize = mdSize;
      this.setState({ showExportModal: true });
    }
  }

  onFileExportCancel() {
    this.setState({ showExportModal: false });
  }

  onFileExportOk() {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    const paramSearch = this.createParams(true, formValues, null, 0);
    this.props.dispatch(EmailAction.exportEmailCSV(paramSearch)).then(() => {
      showExportCSVSuccessMessage();
    });
    this.setState({ showExportModal: false });
  }

  getStartEndData(startPosition) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let column = null;
    if (formValues && formValues.emailSortType) {
      column = formValues.emailSortType;
    }
    this.searchData(startPosition, column);
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  render() {
    const { groupList, emailList, recordNum, startPosition } = this.props;
    const { searchInfo, hoverIndex } = this.state;
    return (
      <div>
        <MessageSearch
          recordNum={recordNum}
          resultList={emailList}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <EmailSearch
          {...this.state.searchInfo}
          groupList={groupList}
          showSelectGroupDlg={this.showSelectGroupDlg}
          removeSelectedGroup={this.removeSelectedGroup}
          onSearchBtnClick={this.clickSearchButton}
          onExportBtnClick={this.openFileExportConfirm}
        />
        <EmailList
          onDetailClick={this.handleShowDetailDialog}
          handleSortState={this.handleSortState}
          mailList={emailList}
          getStartEndData={this.getStartEndData}
          recordNum={recordNum}
          startPosition={startPosition}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          hoverIndex={hoverIndex}
        />
        <ModalConductor
          formKey="emailListSearchForm"
        />
        <SelectGroupDlg
          showModal={this.state.showSelectGroup}
          selectedGroup={searchInfo.selectedGroup}
          groupList={groupList}
          onCancel={this.cancelSelectGroupDlg}
          onOK={this.okSelectGroupDlg}
        />

        <DialogConfirm
          showModal={this.state.showExportModal}
          onCancel={this.onFileExportCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onFileExportOk}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const invalid = isInvalid('emailListSearchForm')(state);
  const { groupList } = state.email;
  const { parentPath, searchCondition } = state.page;
  const { emailList, recordNum } = state.email;
  let initial = {};
  if (parentPath === EMAIL_LIST) {
    initial = searchCondition;
  }
  return {
    invalid,
    groupList,
    emailList,
    recordNum,
    initialValues: initial,
    formValues: getFormValues('emailListSearchForm')(state),
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'emailListSearchForm',
    touchOnChange: true,
  })(EmailListContainer),
);
